
import Diplomes from "../../components/Diplomes/diplomes"
import "../../pages/Compétences/compétences.css"
function Compétences (){
    return(
        < Diplomes />
    )
}
export default Compétences